import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'
import { DavidGoalProgress } from './DavidGoalProgress'

interface HelpLightSectionProps {
  releaseDate?: string
  ref?: React.Ref<HTMLElement>
}

export const HelpLightSection = ({ releaseDate, ...rest }: HelpLightSectionProps) => {
  const { t } = useTranslate('pif')

  return (
    <section
      {...rest}
      className="relative w-full bg-[#48c7d8] px-4 pb-[6rem] pt-12 md:flex md:items-center md:px-12 md:py-[7.5rem] lg:px-[4rem] lg:py-[10rem]"
    >
      <div className="mx-auto w-full max-w-[1440px] md:items-center lg:flex lg:flex-row-reverse lg:gap-10 xl:gap-[4rem]">
        <div
          style={{ aspectRatio: 1 }}
          className="relative mx-auto min-w-[370px] max-w-[370px] grow-1 md:max-h-[672px] md:max-w-[672px] xl:max-h-[692px] xl:max-w-[692px]"
        >
          <Image
            alt="David with his lamb"
            src="/v1760542706/theatrical/david/david-tali-isolated-characters.png"
            fill
            className="object-cover"
          />
        </div>

        <div className="mt-8 flex w-full flex-col items-start justify-center gap-8 md:mt-10 lg:mt-0 lg:w-1/2 lg:flex-[1_0_0] lg:gap-10">
          <div className="relative flex w-full flex-col items-start gap-3">
            <p className="font-angel-royal relative w-full text-5xl lowercase not-italic leading-[2.5rem] text-[#141447] md:text-[4rem] md:leading-[3rem]">
              {t('davidHelpLightTitle', 'Help Light up Theaters Dec. 19')}
            </p>
            <Text weight="medium" className="photon-paragraph-lg md:photon-paragraph-xl !text-[#141447]">
              {t(
                'davidHelpLightDescription',
                'Your support helps put DAVID on more screens this Christmas—making room for families to encounter a story of faith, courage, and hope where it matters most.',
              )}
            </Text>
          </div>

          <DavidGoalProgress
            releaseDate={releaseDate}
            textColor="#141447"
            progressBarBg="bg-white"
            progressBarBorder="border-white"
            progressBarFillBg="bg-[#141447]"
            textSize="md"
            shouldAnimateOnScroll={true}
          />

          <div className="relative flex w-full flex-col items-center gap-[8px] md:flex-row md:items-start">
            <DavidButton variant="dark" openPifOverlay className="w-full md:w-auto">
              {t('payItForward', 'Pay it Forward')}
            </DavidButton>
            <DavidButton variant="beige" href="/tickets/david" className="w-full md:w-auto">
              {t('getShowtimes', 'Get Showtimes')}
            </DavidButton>
          </div>
        </div>
      </div>
    </section>
  )
}
